import { LanguageConfigSource, MeetingLanguage, RoomSessionLanguageConfig } from '../models/Room'
import { UserLanguage } from '../models/User'

export const LANGUAGE_OPTIONS_WITH_AUTO_DETECT = [
  { id: 'en', label: 'English', labelShort: 'En' },
  { id: 'es', label: 'Spanish', labelShort: 'Es' },
  { id: 'auto-detect', label: 'Auto-Detect', labelShort: 'Auto-Detect' },
]

export const LANGUAGE_OPTIONS = [
  { id: 'en', label: 'English', labelShort: 'En' },
  { id: 'es', label: 'Spanish', labelShort: 'Es' },
]

export const getLanguageLabel = (language?: MeetingLanguage | null): string => {
  return LANGUAGE_OPTIONS_WITH_AUTO_DETECT.find((option) => option.id === language)?.label || 'English'
}

export const getLanguageShortLabel = (language?: MeetingLanguage | null): string => {
  return LANGUAGE_OPTIONS_WITH_AUTO_DETECT.find((option) => option.id === language)?.labelShort || 'En'
}

export const getContactLanguageLabel = (language?: UserLanguage | null): string => {
  return LANGUAGE_OPTIONS.find((option) => option.id === language)?.label || 'English'
}

export const getContactLanguageLabelShort = (language?: UserLanguage | null): string | null => {
  return LANGUAGE_OPTIONS.find((option) => option.id === language)?.labelShort ?? null
}

export const isLanguageCalculated = (languageConfig: RoomSessionLanguageConfig): boolean => {
  return languageConfig.source !== LanguageConfigSource.MANUAL && languageConfig.source !== LanguageConfigSource.DEFAULT
}

export const getLanguageSource = (languageConfig: RoomSessionLanguageConfig): string | null => {
  switch (languageConfig.source) {
    case LanguageConfigSource.CALCULATED_MAJORITY:
      return ' (most common)'
    case LanguageConfigSource.CALCULATED_ACCOUNT_CONFIG:
    case LanguageConfigSource.NO_CLIENTS_ACCOUNT_CONFIG:
      return ' (fallback)'
    case LanguageConfigSource.CALCULATED_UNAMBIGUOUS:
      return ' (all the same)'
    default:
      return null
  }
}
